import { Route, Routes } from "react-router-dom"

import { MapAdapterBoundingBox, NetworkReferentialLayer } from "@l2r-front/l2r-networks"
import { API_MODULE_CAMPAIGN, MODULE_CAMPAIGNS } from "@l2r-front/l2r-shared-campaign"

import { CampaignLayer } from "../../containers/CampaignLayer"
import { MultiCampaignsLayer } from "../../containers/MultiCampaignsLayer"

import { CampaignValidator } from "../CampaignValidator"

export const CampaignMapRouterMobile = () => {

    return (
        <Routes>
            <Route
                element={
                    <>
                        <NetworkReferentialLayer module={API_MODULE_CAMPAIGN} />
                        <MultiCampaignsLayer />
                        <MapAdapterBoundingBox key="campaign-list" module={API_MODULE_CAMPAIGN} />
                    </>
                }
                path={`/${MODULE_CAMPAIGNS}`}
            />
            <Route
                element={
                    <>
                        <NetworkReferentialLayer module={API_MODULE_CAMPAIGN} />
                        <CampaignLayer />
                        <MapAdapterBoundingBox key="campaign-list" module={API_MODULE_CAMPAIGN} />
                        <CampaignValidator />
                    </>
                }
                path={`/${MODULE_CAMPAIGNS}/:campaignId`}
            />
        </Routes>
    )
}